import React from 'react';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { useCurrentUserVerifier } from 'src/hooks/verifier';

import {
  InboxFilterDateCreatedField,
  InboxFilterEmployeeField,
  InboxFilterEmployerField,
  InboxFilterStatusField,
  InboxFilterVerificationRequestTypeField,
  InboxFilterVerifierField,
  InboxFilterVerifierTypeField,
} from './components';
import { InboxFilterPEOField } from './components/InboxFilterPEOField';

interface InboxFilterFieldsProps {
  disabled: boolean;
}

export const InboxFilterFields: React.FC<InboxFilterFieldsProps> = ({ disabled }) => {
  const {
    hasPlatformRoles,
    hasVerifierRoles,
    hasEmployerRoles,
    hasPeoRoles,
    isEmployee,
    isPeoPayrollProviderUser,
  } = useCurrentUserPermissions();

  const { isCommercialVerifier } = useCurrentUserVerifier();

  if (hasPlatformRoles) {
    return (
      <React.Fragment>
        <InboxFilterStatusField disabled={disabled} />
        <InboxFilterEmployerField disabled={disabled} />
        <InboxFilterVerifierField disabled={disabled} />
        <InboxFilterEmployeeField disabled={disabled} />
        <InboxFilterDateCreatedField disabled={disabled} />
      </React.Fragment>
    );
  }

  if (hasVerifierRoles) {
    return (
      <React.Fragment>
        <InboxFilterStatusField disabled={disabled} />
        {isCommercialVerifier && <InboxFilterVerificationRequestTypeField disabled={disabled} />}
        <InboxFilterEmployeeField disabled={disabled} />
        <InboxFilterDateCreatedField disabled={disabled} />
      </React.Fragment>
    );
  }

  if (hasEmployerRoles) {
    return <InboxFilterStatusField disabled={disabled} />;
  }

  if (hasPeoRoles) {
    return (
      <React.Fragment>
        <InboxFilterStatusField disabled={disabled} />
        <InboxFilterEmployerField disabled={disabled} />
      </React.Fragment>
    );
  }

  if (isPeoPayrollProviderUser) {
    return (
      <React.Fragment>
        <InboxFilterStatusField disabled={disabled} />
        <InboxFilterEmployerField disabled={disabled} />
        <InboxFilterPEOField disabled={disabled} />
      </React.Fragment>
    );
  }

  if (isEmployee) {
    return (
      <React.Fragment>
        <InboxFilterStatusField disabled={disabled} />
        <InboxFilterVerifierTypeField disabled={disabled} />
        <InboxFilterVerifierField disabled={disabled} />
        <InboxFilterDateCreatedField disabled={disabled} />
      </React.Fragment>
    );
  }

  return null;
};
